import { defineMessages } from "react-intl";

export default defineMessages({
  subscriptionFormulaShort: {
    id: "subscriptionFormulaCard.subscriptionFormulaShort",
    defaultMessage: "Ring Twice<plus></plus>",
  },
  subscriptionFormula: {
    id: "subscriptionFormulaCard.subscriptionFormula",
    defaultMessage: "Ring Twice<plus></plus> Formula",
  },
  zeroServiceFeeOnAllServices: {
    id: "subscriptionFormulaCard.zeroServiceFeeOnAllServices",
    defaultMessage: "<bold>0% service fee</bold> on all Ring Twice services.",
  },
  spOffer: {
    id: "subscriptionFormulaCard.spOffer",
    defaultMessage: "{serviceProviderName}'s offer",
  },
  serviceEstimate: {
    id: "subscriptionFormulaCard.serviceEstimate",
    defaultMessage: "Service estimate",
  },
  xServiceFee: {
    id: "subscriptionFormulaCard.xServiceFee",
    defaultMessage: "{serviceFeePercentage}% service fee",
  },
  choose: {
    id: "subscriptionFormulaCard.choose",
    defaultMessage: "Choose",
  },
  xPerMonth: {
    id: "subscriptionFormulaCard.xPerMonth",
    defaultMessage: "{price}/ month",
  },
  otherBenefits: {
    id: "subscriptionFormulaCard.otherBenefits",
    defaultMessage: "Other benefits",
  },
  youCanCancelYourSubscriptionRenewalAtAnyMoment: {
    id: "subscriptionFormulaCard.youCanCancelYourSubscriptionRenewalAtAnyMoment",
    defaultMessage: "Cancel your subscription renewal at any time.",
  },
  enjoyTheFullExperience: {
    id: "subscriptionFormulaCard.enjoyTheFullExperience",
    defaultMessage:
      "Enjoy the full experience and don't worry about anything else.",
  },
});
